import { createFileRoute } from '@tanstack/react-router';
import { PortalOverview } from '@/features/portal/PortalOverview';

export const Route = createFileRoute('/_portal/portal/')({ component: PortalOverview });
